import { Icon, Stack, Text } from '@chakra-ui/react';
import { ElementType } from 'react';

type Props = {
  label: string;
  displayValue: string;
  isSelected: boolean;
  icon: ElementType;
  onOpen: () => void;
};

export const SimplePickerField = ({ label, displayValue, isSelected, icon, onOpen }: Props) => (
  <Stack
    w="full"
    p="4"
    cursor="pointer"
    tabIndex={0}
    onClick={onOpen}
    onKeyDown={(e) => {
      if (e.key === 'Enter') onOpen();
    }}
  >
    <Text textStyle="label">{label}</Text>
    <Stack direction="row" w="full" alignItems="center" spacing="3" h="full">
      <Icon as={icon} />
      <Text fontSize="md" color={isSelected ? 'text.default' : 'text.placeholder'} noOfLines={1}>
        {displayValue}
      </Text>
    </Stack>
  </Stack>
);
